// Mock data for InArch Design Studio

export const portfolioImages = {
  hero: [
    'https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE0OTJ8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE0OTJ8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE0OTJ8MA&ixlib=rb-4.1.0&q=85'
  ],
  livingRooms: [
    'https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2ODM4MTQ5N3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2ODM4MTQ5N3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2ODM4MTQ5N3ww&ixlib=rb-4.1.0&q=85'
  ],
  bedrooms: [
    'https://images.unsplash.com/photo-1763478958711-dd84b33cfe16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmVkcm9vbXxlbnwwfHx8fDE3NjgzODE1MDN8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1763478959550-13d564c5a62d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYmVkcm9vbXxlbnwwfHx8fDE3NjgzODE1MDN8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1766928210443-0be92ed5884a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYmVkcm9vbXxlbnwwfHx8fDE3NjgzODE1MDN8MA&ixlib=rb-4.1.0&q=85'
  ],
  kitchens: [
    'https://images.unsplash.com/photo-1556912167-f556f1f39fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2ODM4MTUwOXww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2ODM4MTUwOXww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2ODM4MTUwOXww&ixlib=rb-4.1.0&q=85'
  ],
  offices: [
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE1MTV8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1600508773950-d522f5bb7606?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE1MTV8MA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjgzODE0OTJ8MA&ixlib=rb-4.1.0&q=85'
  ]
};

export const portfolioProjects = [
  {
    id: 1,
    title: 'Modern Minimalist Living',
    category: 'Residential',
    type: 'Living Room',
    image: portfolioImages.livingRooms[0],
    description: 'A serene living space with clean lines and warm textures'
  },
  {
    id: 2,
    title: 'Executive Suite Bedroom',
    category: 'Residential',
    type: 'Bedroom',
    image: portfolioImages.bedrooms[0],
    description: 'Luxurious master bedroom with sophisticated details'
  },
  {
    id: 3,
    title: 'Contemporary Kitchen Design',
    category: 'Residential',
    type: 'Kitchen',
    image: portfolioImages.kitchens[0],
    description: 'Functional elegance with premium finishes'
  },
  {
    id: 4,
    title: 'Corporate Headquarters',
    category: 'Commercial',
    type: 'Office',
    image: portfolioImages.offices[0],
    description: 'Productivity-driven workspace with architectural details'
  },
  {
    id: 5,
    title: 'Warm Living Sanctuary',
    category: 'Residential',
    type: 'Living Room',
    image: portfolioImages.livingRooms[1],
    description: 'Cozy contemporary space with natural elements'
  },
  {
    id: 6,
    title: 'Serene Bedroom Retreat',
    category: 'Residential',
    type: 'Bedroom',
    image: portfolioImages.bedrooms[1],
    description: 'Peaceful sanctuary with elegant proportions'
  },
  {
    id: 7,
    title: 'Gourmet Kitchen Elegance',
    category: 'Residential',
    type: 'Kitchen',
    image: portfolioImages.kitchens[1],
    description: 'Dark sophistication meets modern functionality'
  },
  {
    id: 8,
    title: 'Modern Open Office',
    category: 'Commercial',
    type: 'Office',
    image: portfolioImages.offices[1],
    description: 'Collaborative workspace with refined aesthetics'
  },
  {
    id: 9,
    title: 'Coastal Living Room',
    category: 'Residential',
    type: 'Living Room',
    image: portfolioImages.livingRooms[2],
    description: 'Light-filled space with natural textures'
  },
  {
    id: 10,
    title: 'Designer Bedroom Suite',
    category: 'Residential',
    type: 'Bedroom',
    image: portfolioImages.bedrooms[2],
    description: 'Contemporary comfort with curated details'
  },
  {
    id: 11,
    title: 'White Kitchen Paradise',
    category: 'Residential',
    type: 'Kitchen',
    image: portfolioImages.kitchens[2],
    description: 'Bright, airy kitchen with professional aesthetics'
  },
  {
    id: 12,
    title: 'Executive Boardroom',
    category: 'Commercial',
    type: 'Office',
    image: portfolioImages.offices[2],
    description: 'Sophisticated meeting space for important decisions'
  }
];

export const services = {
  residential: [
    {
      title: 'Sophisticated Living Rooms',
      description: 'Elegant spaces that balance comfort and style, designed for modern living.'
    },
    {
      title: 'Personalized Bedrooms',
      description: 'Cozy, personalized sanctuaries that reflect your unique personality.'
    },
    {
      title: 'Elegant Kitchens & Dining',
      description: 'Functional, beautiful spaces where culinary dreams come to life.'
    },
    {
      title: 'Seamless Storage Solutions',
      description: 'Smart storage that keeps your space organized without compromising style.'
    }
  ],
  commercial: [
    {
      title: 'Productivity-Driven Offices',
      description: 'Workspaces designed to inspire creativity and enhance productivity.'
    },
    {
      title: 'Engaging Retail Spaces',
      description: 'Captivating environments that tell your brand story.'
    },
    {
      title: 'Elegant Hospitality Interiors',
      description: 'Warm, welcoming spaces that leave lasting impressions.'
    }
  ],
  landscape: [
    {
      title: 'Garden Design',
      description: 'Transform your outdoor space into a beautiful, functional garden.'
    },
    {
      title: 'Outdoor Living Areas',
      description: 'Create stunning patios, decks, and outdoor entertainment spaces.'
    },
    {
      title: 'Sustainable Landscaping',
      description: 'Eco-friendly landscape solutions that conserve water and resources.'
    }
  ],
  villasResorts: [
    {
      title: 'Luxury Villa Interiors',
      description: 'Premium interior design for exclusive villas and private residences.'
    },
    {
      title: 'Resort & Hospitality',
      description: 'Creating memorable guest experiences through thoughtful design.'
    },
    {
      title: 'Pool & Spa Areas',
      description: 'Relaxing wellness spaces that blend with natural surroundings.'
    }
  ],
  additional: [
    {
      title: 'Modular Kitchens',
      description: 'Custom-designed kitchens tailored to your cooking style.'
    },
    {
      title: 'Custom Wardrobes',
      description: 'Bespoke storage solutions that fit your lifestyle perfectly.'
    },
    {
      title: 'Conceptual Designs',
      description: 'Creative visions brought to life through detailed concept development.'
    },
    {
      title: '3D Visualizations',
      description: 'Realistic renderings that help you see your space before construction.'
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Homeowner, Mumbai',
    content: 'InArch transformed our apartment into a stunning home. Their attention to detail and understanding of our lifestyle made all the difference.',
    rating: 5
  },
  {
    id: 2,
    name: 'Rajesh Mehta',
    role: 'CEO, Tech Solutions',
    content: 'Our new office space has completely transformed how our team works. The design is both functional and inspiring.',
    rating: 5
  },
  {
    id: 3,
    name: 'Anita Desai',
    role: 'Restaurant Owner',
    content: "The hospitality interior they designed for us has received countless compliments from our guests. Truly exceptional work.",
    rating: 5
  }
];

export const stats = [
  { value: '400+', label: 'Projects Completed' },
  { value: '20+', label: 'Years Experience' },
  { value: '98%', label: 'Client Satisfaction' }
];

export const contactInfo = {
  address: {
    line1: 'Office no. 220, Skylark, Plot no. 63,',
    line2: 'Shahbaz Village, Sector 11,',
    line3: 'CBD Belapur, Navi Mumbai,',
    line4: 'Maharashtra – 400614'
  },
  phone: '+91 8591613610',
  phone2: '+91 9820336742',
  email: 'inarchdesignstudiovashi@gmail.com',
  instagram: '@inarch_design_studio_belapur',
  social: {
    instagram: 'https://instagram.com/inarch_design_studio_belapur',
    facebook: 'https://www.facebook.com/share/1b956kRa3A/',
    google: 'https://g.page/inarchdesignstudio'
  }
};
